export * from './selectFetch.service';
import { SelectFetchService } from './selectFetch.service';
export * from './selectFetch.serviceInterface';
export const APIS = [SelectFetchService];
